module.exports = __webpack_public_path__ + "static/media/Megaphone.772f16ee.svg";